import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import app1 from "../image/app1.jpg";
import app2 from "../image/app2.jpg";
import app3 from "../image/app3.jpg";
import app4 from "../image/app4.jpg";
import app5 from "../image/app5.jpg";
import app6 from "../image/app6.jpg";
import app7 from "../image/app7.jpg";
import app8 from "../image/app8.jpg";
import app9 from "../image/app9.jpg";
import app10 from "../image/app10.png";

const AppPic = () => {
  const [centerSlidePercentage, setCenterSlidePercentage] = useState(30);

  // Function to handle window resize
  const handleResize = () => {
    if (window.innerWidth < 768) {
      setCenterSlidePercentage(70); // Set to 70% on smaller screens
    } else {
      setCenterSlidePercentage(20); // Set back to 30% on larger screens
    }
  };

  // Effect to handle the resize event
  useEffect(() => {
    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize); // Add event listener

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const styles = `
    .carousel-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2rem;
      width: 94vw;
      overflow: hidden; /* Added overflow hidden */
    }
  
    .text-section {
      width: 50vw;
      text-align: left;
      padding-right: 1rem;
    }
  
    .text-section h2 {
      font-size: 2rem;
      font-weight: bold;
      color: #3b1464; 
    }
  
    .text-section p {
      font-size: 1rem;
      color: #6d6d6d;
      line-height: 1.5;
    }
  
    .carousel {
      width: 20vw;
    }
  
    .img-container {
      display: flex;
      justify-content: center;
      max-height: 300px;
      margin-bottom: 1vh;
      overflow: hidden; /* Added overflow hidden */
    }
  
    .img-container img {
      max-width: 100%;
      max-height: 300px;
      width: auto;
      height: auto;
      border-radius: 15px;
      object-fit: contain;
    }
  
    .carousel .slider-wrapper {
      max-height: 300px;
    }
  
    .carousel .slider .slide {
      display: flex;
      justify-content: center;
    }

    @media (max-width: 768px) {
      .carousel-container {
        flex-direction: column; /* Stack the text and carousel vertically */
        width: 95vw;
        padding: 0rem;
        padding-bottom: 2rem;
      }

      .text-section, .carousel {
        width: 100%; /* Make both take full width */
        text-align: center; /* Center the text on smaller screens */
      }

      .text-section {
        padding-right: 0;
      }

      .text-section h2 {
        font-size: 1.5rem; /* Reduce heading size on smaller screens */
      }

      .text-section p {
        font-size: 0.9rem; /* Reduce text size on smaller screens */
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <div className="carousel-container" id="AppScreenshots">
        <div className="text-section">
          <h2>Software Overview</h2>
          <p>
            The Physio-Mize software offers an intuitive interface for tracking
            rehabilitation and providing feedback. It monitors joint angles and
            pain levels in real time, using 3D models and advanced algorithms
            for accurate movement tracking and personalized treatment
            adjustments.
          </p>
        </div>
        <Carousel
          showThumbs={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={3000}
          transitionTime={500}
          showStatus={false}
          centerMode={true}
          centerSlidePercentage={centerSlidePercentage}
        >
          <div className="img-container">
            <img src={app1} alt="App Screenshot 1" />
          </div>
          <div className="img-container">
            <img src={app2} alt="App Screenshot 2" />
          </div>
          <div className="img-container">
            <img src={app3} alt="App Screenshot 3" />
          </div>
          <div className="img-container">
            <img src={app4} alt="App Screenshot 4" />
          </div>
          <div className="img-container">
            <img src={app5} alt="App Screenshot 5" />
          </div>
          <div className="img-container">
            <img src={app6} alt="App Screenshot 6" />
          </div>
          <div className="img-container">
            <img src={app7} alt="App Screenshot 7" />
          </div>
          <div className="img-container">
            <img src={app8} alt="App Screenshot 8" />
          </div>
          <div className="img-container">
            <img src={app9} alt="App Screenshot 9" />
          </div>
          <div className="img-container">
            <img src={app10} alt="App Screenshot 10" />
          </div>
        </Carousel>
      </div>
    </>
  );
};

export default AppPic;
